import { Box, Button, Stack, Typography } from '@mui/material';
import React, { Component } from 'react';
import WithRouter from '../Layout/Router/WithRouter';
import { JobTriggerCard } from './JobTriggerCard';

class AdminFunctions extends Component {
  state = {
    id: 'samAdminFunctions',
  };

  render() {
    return (
      <React.Fragment>
        <Box
          id={`${this.state.id}__box_wrapper`}
          sx={{
            border: '1px solid #ccc',
            padding: 2,
            borderRadius: 2,
          }}
          width={'fit-content'}
        >
          <Typography
            id={`${this.state.id}__text_administration`}
            component="h3"
            className="text-center"
          >
            Admin Only
          </Typography>
          <Stack
            direction={'column'}
            alignItems={'center'}
            spacing={2}
            id={`${this.state.id}__stack_wrapper`}
          >
            <img id={`${this.state.id}__img_logo`} src="/img/samAutoJob.svg" alt="SAM Auto Job" />

            <Stack direction={{ xs: 'column' }} spacing={2}>
              {this.props.samAdminPages.map((page) => {
                return (
                  <Button
                    key={page.id}
                    variant="outlined"
                    id={`${page.id}__button`}
                    onClick={() => this.props.navigate(`/${this.props.url}/${page.url}`)}
                  >
                    {page.label}
                  </Button>
                );
              })}
            </Stack>
          </Stack>
        </Box>
      </React.Fragment>
    );
  }
}

export default WithRouter(AdminFunctions);
